import React, { useState } from 'react';
import classnames from 'classnames';
import { formatCurrency, formatPercentage } from '../../../../lib/helpers';

const TableRow = ({
  label,
  subLabel,
  valueType,
  value,
  className,
  children,
  colSpan,
  type,
  ...props
}) => {
  // Dynamically render table row based on what type props is set
  if (type === 'checkbox') {
    return (
      <tr className={classnames('tr', className)}>
        <th colSpan={colSpan}>
          {label}
          {subLabel && <small className="u--display-block">{subLabel}</small>}
        </th>
        <td>{children}</td>
        {value !== undefined && (
          <td>
            {valueType === 'currency'
              ? formatCurrency(value)
              : formatPercentage(value) && value}
          </td>
        )}
      </tr>
    );
  } else if (type === 'input') {
    return (
      <tr className={classnames('tr', className)}>
        <th colSpan={colSpan}>
          {label}
          {subLabel && <small className="u--display-block">{subLabel}</small>}
        </th>
        <td>{children}</td>
      </tr>
    );
  } else {
    return (
      <tr className={classnames('tr', className)}>
        <th colSpan={colSpan}>
          {label}
          {subLabel && <small className="u--display-block">{subLabel}</small>}
        </th>
        {children && <td>{children}</td>}
        {value !== undefined && (
          <td>
            {valueType === 'currency'
              ? formatCurrency(value)
              : formatPercentage(value) && value}
          </td>
        )}
      </tr>
    );
  }
};

export default TableRow;
